import { CircularProgress, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@mui/material';
import MDButton from 'components/MDButton';
import React from 'react';
import { useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';

export default function ConfirmModalStatus({ closeModal }) {
  const { modalData, isLoading = false } = useSelector(state => state.modal);
  const { saveHandler, Type ,templatename,SwitchTab} = modalData;

  return (
    <>
      <DialogTitle id='draggable-dialog-title' display='flex' alignItems='center' justifyContent='space-between'>
      Caution
        <IconButton onClick={closeModal} edge='end' size='small'>
          <CloseIcon fontSize='medium' />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {/* Are you sure you want to Change {Type}? */}
          Leaving this <span style={{textTransform:"lowercase"}}>{Type}</span>  will reset your progress. Continue?
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <MDButton onClick={closeModal} size='small' color='secondary'>
          No
        </MDButton>
        <MDButton onClick={() => saveHandler(Type,templatename,SwitchTab)} size='small' color='error'>
          {
            isLoading ? <CircularProgress size={16} color='light' /> : 'Yes'
          }
        </MDButton>
      </DialogActions>
    </>
  );
}